<template>
  <div class="cardd relative" :class="bg_color">
   <loading :active.sync="loading" :is-full-page="fullPage"></loading>
    <div  class="cardd-body">
       <div  class="media align-items-center">
          <div  class="w-icon pr-3 text-white"> <i class="material-icons">{{statIconName}}</i></div>
          <div  class="media-body pl-3 border-left border-white-2">
              <span  class="text-white font-bold">{{statSubtitle}}</span>
             <h5  class="text-white font-small mb-0">{{datas.sum||datas.count}} <sup v-if="currency">{{currency}}</sup></h5>
             <p  class="extra-small-font mb-3 text-white">{{Math.sign(datas.since) === 1?'+':''}}{{datas.since}}% <i class="material-icons">{{Math.sign(datas.since) === -1?'trending_down':'trending_up' }}</i> Since Last Month</p>
          </div>
       </div>
    </div> 
   </div>
</template>
<script>
export default {
  name: "card-stats-v7",
  props: {
    statSubtitle: {
      default: "Traffic",
    },
    loading:{required:false},
    timeserch:{},
    titleRate:{},
    from:{},
    to:{},
    filter: {
      default: false,
    },
    statTitle: {},
    action: {},
    statArrow: {
      default: "up",
      validator: function (value) {
        // The value must match one of these strings
        return ["up", "down"].indexOf(value) !== -1;
      },
    },
    statPercent: {},
    // can be any of the text color utilities
    // from tailwindcss
    statPercentColor: {
      default: "text-green-500",
    },
    statDescripiron: {},
    id:{type:String},
    bg_color:{type:String},
    color:{type:String},
    trending:{type:String},
    currency: {default:false},
    count:{type: Number,default:0},
    datas:{type:Object},
    dataChart:{type:Array},
    countText:{},
    rate:{},
    statIconName: {
      default: "far fa-chart-bar",
    },
    // can be any of the background color utilities
    // from tailwindcss
    statIconColor: {
      type: String,
      default: "bg-red-500",
    },
  },
  data() {
    return {
      fullPage: false,
       timeserchtype:this.timeserch,
      myChart: "",
    };
  },
 watch: {
   
  },
  async mounted(){
   
  },
   methods: {
    ChangeDateConfirmation: function (val) {
      this.$emit("ChangeDateConfirmation", val);
    },
    //  FindRecords: function () {
    //   this.$emit("FindRecords", this.action,this.fromDate,this.toDate);
    // },
   }
};
</script>
<style scoped>
.gradient-shifter {
    background: linear-gradient(45deg,#bc4e9c,#f80759) !important;
}
.gradient-deepblue {
    background: #6a11cb;
    background: linear-gradient(45deg,#6a11cb,#2575fc) !important;
}
.gradient-ohhappiness {
    background: #00b09b;
    background: linear-gradient(45deg,#00b09b,#96c93d) !important;
}
.gradient-ibiza {
    background: #ee0979;
    background: linear-gradient(45deg,#ee0979,#ff6a00) !important;
}
.gradient-orange {

    background: #fc4a1a;
    background: linear-gradient(45deg,#fc4a1a,#f7b733) !important;

}
.extra-small-font {
    font-size: 12px;
}
.cardd {
    border: none;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    border-radius: .25rem;
    flex: 1 1 auto;
    min-height: 1px;
}
.align-items-center {
    align-items: center;
}
.media .w-icon i {
    font-size: 35px;
}
.border-white-2 {
    border-color: hsla(0,0%,100%,.33) !important;
}
.border-left {
    border-left: 1px solid #dee2e6 !important;
}
.media-body {
    flex: 1;
}
.small-font {
    font-size: 14px;
}
.media {
    display: flex;
}
.cardd-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
}
</style>
